import ky from 'ky-universal';
import { normalize, schema } from 'normalizr';
import { isBrowser } from 'browser-or-node';

import { drama } from '../constants/actionTypes';
import isUndefined from '../utils/type-check/isUndefined';
import { staticHost, localFetchDramaInfo } from '../../config/api';

import editImage from '../utils/editImage';

export const fetchDramaInfo = (dramaId) => {
  return async (dispatch, getState) => {
    const state = getState();

    if (isBrowser && !isUndefined(state.entities.dramaInfo.byId[dramaId])) {
      return;
    }

    dispatch({ type: drama.FETCH_DRAMAINFO });

    try {
      const res = await ky.get(localFetchDramaInfo(dramaId));
      const stringifiedData = (await res.json()).info;
      const dramaInfo = JSON.parse(stringifiedData);

      const editedHorizontalPosterUrl = editImage(
        dramaInfo.horizontal_poster_url,
        {
          resize: { width: state.deviceType.isMobile ? 340 : 850 },
          toFormat: 'jpeg',
          jpeg: { quality: 50, progressive: true },
        }
      );

      dispatch({
        type: drama.FETCH_DRAMAINFO_SUCCESS,
        payload: {
          id: dramaId,
          data: {
            ...dramaInfo,
            editedHorizontalPosterUrl,
          },
        },
      });
    } catch (error) {
      dispatch({ type: drama.FETCH_DRAMAINFO_FAILED, error });
    }
  };
};

export function fetchDramaCategories() {
  return async (dispatch, getState) => {
    if (isBrowser && getState().drama.categories.length > 0) {
      return;
    }

    dispatch({ type: drama.FETCH_DRAMA_CATEGORY });

    const res = await ky(`${staticHost}/api/drama/category.json`);
    const { data: categories } = await res.json();

    const categoryEntity = new schema.Entity('categories');
    const normalizedData = normalize(categories, [categoryEntity]);

    dispatch({
      type: drama.FETCH_DRAMA_CATEGORY_SUCCESS,
      payload: { normalizedData },
    });
  };
}
